import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';

import Cart from './img/cart.svg'
import { isMobile, isTablet } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

import AOS from "aos";
import "aos/dist/aos.css";

import { Header } from "../../header";
import { Footer } from "../../components/footer";

export const MerchPage = () => {
  const scrollTo = (section) => {
    const element = document.getElementById(section);
    if (element) {
      const headerOffset = 85;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("none");
  const [typeOrder, setTypeOrder] = useState("none");

  const [preview, setPreview] = useState({})
  const [settings, setSettings] = useState([])

  const fetchPreview = async () => {
    try {
      const response = await fetch("https://api.alyonatestsite.store/api/settings");
      if (!response.ok) throw new Error("Ошибка загрузки данных");
      
      const data = await response.json();
      const newSettings = data.priorityTags || [];
      
      setPreview(data.merchPage);
      setSettings(newSettings);

    } catch(err) {
      console.error("Ошибка:", err);
    }
  }

  const fetchProducts = async () => {
    try {
      const response = await fetch("https://api.alyonatestsite.store/api/products");
      if (!response.ok) {
        throw new Error("Ошибка загрузки данных");
      }
      const data = await response.json();
      setProducts(data);
    } catch (err) {
    }
  };
  

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    document.title = "Магазин Алёны Швец";
    fetchProducts();
    fetchPreview();
  }, []);

  useEffect(() => {
    const filtered = products.filter(product =>
      product.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
    const filteredByType = typeOrder === "none"
      ? filtered
      : filtered.filter(product => product.category === typeOrder);
  
    const sorted = sortOrder === "none"
      ? filteredByType
      : [...filteredByType].sort((a, b) => {
          const priceA = a.discount > 0 ? a.discount : a.price;
          const priceB = b.discount > 0 ? b.discount : b.price;
          return sortOrder === "asc" ? priceA - priceB : priceB - priceA;
        });

    const sortedByPriorityTags = [...sorted].sort((a, b) => {
      if (!settings || settings.length === 0) return 0;
      
      const getMaxTagPriority = (product) => {
        if (!product.tags || product.tags.length === 0) return Infinity;
        
        let maxPriority = Infinity;
        product.tags.forEach(tagId => {
          const tagIndex = settings.findIndex(t => t.id === tagId);
          if (tagIndex !== -1 && tagIndex < maxPriority) {
            maxPriority = tagIndex;
          }
        });
        return maxPriority;
      };
      
      const aPriority = getMaxTagPriority(a);
      const bPriority = getMaxTagPriority(b);
      
      return aPriority - bPriority;
    });
      
    setFilteredProducts(sortedByPriorityTags);
  
    AOS.refresh();
  }, [searchQuery, sortOrder, typeOrder, products, settings]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSortChange = (e) => {
    setSortOrder(e.target.value);
  };

  const handleTypeChange = (e) => {
    setTypeOrder(e.target.value);
  };

  const SkeletonCard = () => (
    <div className="relative w-full sm:w-80 rounded-lg text-left group">
      <div className="w-full h-64 bg-sky-200 relative overflow-hidden mb-3">
        <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
      </div>
      <div className="h-6 w-2/3 bg-sky-200 relative overflow-hidden mb-2">
        <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
      </div>
      <div className="h-3 w-2/4 bg-sky-200 relative overflow-hidden mt-4">
        <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
      </div>
    </div>
  );

  const PreviewCarousel = () => (
    <div className="relative">
      <div className="hidden lg:flex justify-center items-center h-screen lg:h-[600px] bg-sky-400">

        <div className="w-full h-full flex overflow-x relative">
            <div className="flex-shrink-0 w-full h-full relative">
              <img
                src={`https://api.alyonatestsite.store${preview.computerPreview}`}
                alt={`https://api.alyonatestsite.store${preview.computerPreview}`}
                className="object-cover w-full h-full"
                loading="lazy"
              />
              <div className="absolute inset-0 flex justify-end items-center pr-4">
                <div className="text-white rounded-lg w-1/2 text-left space-y-8">
                  <p className="text-6xl font-lack whitespace-pre-line w-3/4">{preview.title}</p>
                  <button onClick={() => scrollTo("catalog")} className="py-2 px-6 rounded-xl bg-white text-black font-lack text-lg">
                    Начать покупки
                  </button>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div className="lg:hidden flex justify-center items-center h-screen bg-sky-400">

      <div className="w-full h-full relative">
  <img
    src={`https://api.alyonatestsite.store${preview.mobilePreview}`}
    alt="mob"
    className="object-cover w-full h-full"
    loading="lazy"
  />
  <div className="absolute flex top-[15%] inset-x-0 justify-center items-center">
    <div className="text-white p-4 rounded-lg text-center flex flex-col justify-center items-center space-y-8">
      <p data-aos="fade-up" className="text-4xl font-lack whitespace-pre-line w-3/4">
        {preview.title}
      </p>
      <button
        onClick={() => scrollTo("catalog")}
        data-aos="fade-up"
        className="py-2 px-6 rounded-xl bg-white text-black font-lack text-lg"
      >
        Начать покупки
      </button>
    </div>
  </div>
</div>
      </div>
    </div>
  );

  const inStockProducts = filteredProducts.filter(product =>
    product.sizes?.length ? product.sizes.some(size => size.quantity > 0) : product.stock > 0
  );

  const outOfStockProducts = filteredProducts.filter(product =>
    product.sizes?.length ? product.sizes.every(size => size.quantity <= 0) : product.stock <= 0
  );

  const promoTagId = 18;


  if (products.length === 0) {
    return (
      <div className="flex flex-col min-h-screen min-h-[100dvh] w-full overflow-x-hidden">
  <Header page="merch" fixed={false} transparent={true} />

  <main className="flex flex-1 flex-col items-center justify-center text-center bg-sky-700 px-4 py-12 sm:px-8 sm:py-16">
    <div className="flex flex-col items-center space-y-4 sm:space-y-6 max-w-2xl">
      <h1 className="font-lack text-white text-3xl leading-tight sm:text-4xl md:text-5xl">
        На данный момент магазин закрыт
      </h1>

      <p className="font-lack font-light text-gray-300 text-base leading-relaxed sm:text-lg md:text-xl">
        Все ранее оформленные заказы были доставлены.
        <br className="hidden sm:block" />{" "}
        При возникновении вопросов, обратитесь в поддержку магазина
      </p>

      <a
        href="https://t.me/alyonashvetsmerch_bot"
        target="_blank"
        rel="noopener noreferrer"
        className="font-lack bg-white text-base sm:text-lg py-3 px-6 rounded-xl w-full sm:w-auto max-w-xs transition hover:bg-gray-100 active:scale-95"
      >
        Связаться с поддержкой
      </a>
    </div>
  </main>

  <Footer />
</div>
    );
  }

  // return (
  //   <div className="w-full h-screen bg-white">
  //     <Header />
  //     <div className="h-full w-full flex justify-center items-center flex-col space-y-8">
  //       <h1 className="font-lack bg-sky-600 text-white rotate px-2 py-1 rounded text-4xl">
  //         Технические работы
  //       </h1>
  //       <p className="text-black text-2xl font-lack text-center xl:w-1/2">
  //         Уже скоро магазин снова возобновит работу. Заказы, оформленные до 4 апреля 2026 года, будут обработаны и отправлены до покупателей.
  //       </p>
  //     </div>
  //     <Footer />
  //   </div>
  // )

  return (
    <div className="h-screen">
      <Header page="merch" fixed={true} transparent={false} />

      <div className="flex flex-col text-center space-y-8 justify-center items-center h-full bg-sky-200 p-8">
        <h1 className="text-4xl font-lack">
          На данный момент магазин закрыт
        </h1>
        <p className="text-center text-lg">
          Все активные заказы уже собраны и переданы в доставку. Следить за их статусом можно в СДЭК или в <a href="https://t.me/alyonashvetsmerch_bot" className="text-blue-400 hover:text-blue-200">Telegram-боте</a>.
        </p>
        {/* <div className="py-16 xl:py-24 px-4 xl:px-0">
          <h1 id="catalog" className="font-lack text-4xl">Каталог</h1>
          <div className="mt-4 w-full max-w-5xl flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 md:space-x-4">
            <input
              type="text"
              data-aos="none"
              placeholder="Поиск по названию товара"
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full md:w-2/3 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
            />
            <select
              value={sortOrder}
              onChange={handleSortChange}
              className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
            >
              <option value="none">Сортировка по цене</option>
              <option value="asc">Цена: по возрастанию</option>
              <option value="desc">Цена: по убыванию</option>
            </select>
            <select
              value={typeOrder}
              onChange={handleTypeChange}
              className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
            >
              <option value="none">Сортировка по типу</option>
              <option value="clothes">Одежда</option>
              <option value="accessories">Аксессуары</option>
              <option value="other">Прочее</option>
            </select>
          </div>

          <div className="bg-white mt-12">
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6 xl:gap-8">
              {inStockProducts.map((product) => (
                <ProductCard key={product.id} product={product} showPrice={true} />
              ))}
            </div>
          </div>

          <div className="mt-12 w-full h-[1px] bg-gray-300" />


          <div className="bg-white mt-12">
            <h2 className="text-2xl font-lack mb-6">Нет в наличии</h2>
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {outOfStockProducts.map((product) => (
                <ProductCard key={product.id} product={product} showPrice={false} />
              ))}
            </div>
          </div>
        </div> */}
      </div>
      <Footer />
      <a
        href="/merch/cart"
        className="cursor-pointer fixed bottom-10 right-10 bg-sky-400 text-white rounded-full p-5 lg:p-8 shadow-lg hover:bg-sky-600 transition duration-300"
      >
        <img alt='cart' src={Cart} className="w-6 h-6" />
      </a>
    </div>
  );
};

const ProductCard = React.memo(({ product, showPrice, color }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [tags, setTags] = useState([]);
  const [showDots, setShowDots] = useState(false);
  const lastMoveTime = useRef(0);
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentImageIndex(0);
  }, [product.id]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get("https://api.alyonatestsite.store/api/tags");
        setTags(response.data);
      } catch (error) {
        console.error("Ошибка загрузки тэгов:", error);
      }
    };
    fetchTags();
  }, []);

  const handleMouseMove = (e) => {
    if (isOutOfStock || isMobile || isTablet) return;

    const now = Date.now();
    if (now - lastMoveTime.current < 100) return;
    lastMoveTime.current = now;

    const { left, width } = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - left;
    const partWidth = width / product.images.length;
    const index = Math.floor(x / partWidth);

    setCurrentImageIndex(index);
  };

  const isOutOfStock = product.sizes?.length
    ? product.sizes.every((size) => size.quantity <= 0)
    : product.stock <= 0;

    const isPriority = product.tags?.includes(24);

  return (
    <div
      onMouseEnter={() => setShowDots(true)}
      onMouseLeave={() => setShowDots(false)}
      onMouseMove={handleMouseMove}
      className={`relative w-full lg:w-80 xl:w-80 rounded-lg text-left group select-none cursor-pointer`}
      onClick={() => window.location.href = isOutOfStock ? "#" : `/merch/product/?id=${product.id}`}
    >
      <div className="relative overflow-hidden">
        <img
          src={`https://api.alyonatestsite.store${product.images[currentImageIndex]}`}
          alt={product.name}
          className={`w-full h-48 md:h-64 mb-3 object-cover transition-opacity duration-200 rounded-xl ${isPriority ? "glowing-border" : ""}`}
          loading="lazy"
        />

        {showDots && !isOutOfStock && !isMobile && !isTablet && (
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1 bg-black/50 px-2 py-1 rounded-full">
            {product.images.map((_, index) => (
              <div
                key={index}
                className={`w-1.5 h-1.5 rounded-full transition-colors ${index === currentImageIndex ? "bg-sky-500" : "bg-gray-400"
                  }`}
              />
            ))}
          </div>
        )}
      </div>

      <div className="absolute top-5 left-5 lg:flex hidden flex-wrap gap-2">
        {(product.discount !== 0 && !isOutOfStock) && (
          <span
            key="discount"
            style={{ backgroundColor: `#ff1414` }}
            className="text-white font-crooker text-sm px-4 py-1 rounded-2xl"
          >
            Скидка -{100 - Math.round((product.discount / product.price) * 100)}%
          </span>
        )}
        {tags.length > 0 && product.tags?.length > 0 && !isOutOfStock && (
          product.tags.map((productTag) => {
            const tag = tags.find((tag) => tag.id === productTag);
            return tag ? (
              <span
                key={tag.id}
                style={{ backgroundColor: `#${tag.color}` }}
                className="text-white font-crooker text-sm px-4 py-1 rounded-2xl"
              >
                {tag.name}
              </span>
            ) : null;
          })
        )}
      </div>

      <div className={`lg:hidden flex flex-wrap gap-2 ${(product.discount !== 0 || tags.length > 0) && !isOutOfStock && `mb-2`}`}>
        {(product.discount !== 0 && !isOutOfStock) && (
          <span
            key="discount"
            style={{ backgroundColor: `#ff1414` }}
            className="text-white font-crooker text-xs lg:text-sm px-4 py-1 rounded-2xl"
          >
            Скидка -{100 - Math.round((product.discount / product.price) * 100)}%
          </span>
        )}
        {tags.length > 0 && product.tags?.length > 0 && !isOutOfStock && (
          product.tags.map((productTag) => {
            const tag = tags.find((tag) => tag.id === productTag);
            return tag ? (
              <span
                key={tag.id}
                style={{ backgroundColor: `#${tag.color}` }}
                className="text-white font-crooker text-xs lg:text-sm px-4 py-1 rounded-2xl"
              >
                {tag.name}
              </span>
            ) : null;
          })
        )}
      </div>

      <h2 className={`text-base lg:text-xl font-lack ${color === "white" ? "text-white" : "text-black"}`}>
  {product.name}
</h2>

      <div className="flex flex-row space-x-2">
      <p className={`${product.discount === 0 ? "font-bold text-gray-400" : color === "white" ? "text-gray-200 font-bold" : "text-sky-600 font-bold"} ${!showPrice && 'hidden'}`}>
  {product.discount === 0 ? product.price : product.discount} ₽
</p>
<p className={`${product.discount === 0 && "hidden"} ${color === "white" ? "text-gray-400" : "text-gray-800"} line-through ${!showPrice && 'hidden'}`}>
  {product.price} ₽
</p>

      </div>
    </div>
  );
});
